import { type YAXisComponentOption } from 'echarts';
import { util } from 'echarts/core';
import { overrideIfUndefined } from '../../../util/data';
import { type ThemeParser } from '../../../core/theme';
import { Z_LIST } from '../static/z';
import { normalizeToArray } from '../../../util/utils';
import {
  fontColor,
  FONT_LEVEL_LIST,
  FONT_SIZE_LIST,
  FONT_WEIGHT_LIST,
  THS_FONTFAMILY_MEDIUM
} from '../static/font';

const DEFAULT_SPLIT_LINE_NUMBER = 5;

function parseYAxisZlevel(yAxises: YAXisComponentOption[]) {
  yAxises.forEach(el => {
    el.z = overrideIfUndefined(el.z, Z_LIST.axisLabel);
  });
}

function parYAxisSplitLine(option: YAXisComponentOption[], colorMode: 'light' | 'dark'): void {
  const baseYAxis = option;
  baseYAxis.forEach(yAxis => {
    const splitLineStyle = {
      show: true,
      dvZ: 0,
      lineStyle: {
        width: 0.5,
        color: colorMode === 'light' ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.06)'
      }
    };
    yAxis.splitLine = util.merge(yAxis.splitLine || {}, splitLineStyle);
  });
}

function parseYAxisLabel(option: YAXisComponentOption[], colorMode) {
  // const [, , optionToken] = args;
  const axisLabelColor = fontColor(FONT_LEVEL_LIST.LEVEL2, colorMode);
  const axisLabelFontSize = FONT_SIZE_LIST.axisLabel;
  option.forEach(yAxis => {
    const dvAlignEdge = yAxis.axisLabel?.dvAlignEdge;
    const defaultAxisLabel = {
      show: true,
      inside: true,
      verticalAlign: 'bottom',
      color: axisLabelColor,
      fontSize: axisLabelFontSize,
      fontFamily: THS_FONTFAMILY_MEDIUM,
      fontWeight: FONT_WEIGHT_LIST.axisLabel,
      margin: 0,
      dvAlignEdge: overrideIfUndefined(dvAlignEdge, true)
    };
    yAxis.axisLabel = util.merge(yAxis.axisLabel || {}, defaultAxisLabel);
  });
}

function parseYAxisLine(option: YAXisComponentOption[]) {
  option.forEach(axis => {
    const defaultAxis = {
      dvSplitLineNumber: DEFAULT_SPLIT_LINE_NUMBER,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    };
    util.merge(axis, defaultAxis);
  });
}
function yAxisParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  option.yAxis = overrideIfUndefined(option.yAxis, {});

  const yAxisArr = normalizeToArray(option.yAxis);

  parseYAxisLine(yAxisArr);
  parseYAxisZlevel(yAxisArr);
}

export function yAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  option.yAxis = overrideIfUndefined(option.yAxis, {});
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  const YAxisArr = normalizeToArray(option.yAxis);
  yAxisParse(...args);
  parseYAxisLabel(YAxisArr, themeMode);
  parYAxisSplitLine(YAxisArr, themeMode);
}
